export default function HelpIcon({ width = 16, height = 17, fill = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M8 13.1094C8.43147 13.1094 8.78125 12.7596 8.78125 12.3281C8.78125 11.8967 8.43147 11.5469 8 11.5469C7.56853 11.5469 7.21875 11.8967 7.21875 12.3281C7.21875 12.7596 7.56853 13.1094 8 13.1094Z" />
        <path d="M8 0.5C3.57863 0.5 0 4.07803 0 8.5C0 12.9214 3.57803 16.5 8 16.5C12.4214 16.5 16 12.922 16 8.5C16 4.07863 12.422 0.5 8 0.5ZM8 15.25C4.26947 15.25 1.25 12.231 1.25 8.5C1.25 4.76947 4.26897 1.75 8 1.75C11.7305 1.75 14.75 4.76897 14.75 8.5C14.75 12.2305 11.731 15.25 8 15.25Z" />
        <path d="M8 4.51562C6.6215 4.51562 5.5 5.63713 5.5 7.01562C5.5 7.36081 5.77981 7.64062 6.125 7.64062C6.47019 7.64062 6.75 7.36081 6.75 7.01562C6.75 6.32638 7.31075 5.76562 8 5.76562C8.68925 5.76562 9.25 6.32638 9.25 7.01562C9.25 7.70487 8.68925 8.26562 8 8.26562C7.65481 8.26562 7.375 8.54544 7.375 8.89062V10.4531C7.375 10.7983 7.65481 11.0781 8 11.0781C8.34519 11.0781 8.625 10.7983 8.625 10.4531V9.43653C9.70206 9.15831 10.5 8.17841 10.5 7.01562C10.5 5.63713 9.3785 4.51562 8 4.51562Z" />
      </g>
    </svg>
  );
}
